/**
 * Implicit brand→org expansion is a browse-only scope. A typed search is a
 * lookup: sending the expanded org-id list through Meilisearch returns no hits.
 *
 * `undefined` means "no org scope"; an empty array means "the brand has no orgs",
 * which callers must turn into an empty result instead of an empty filter value.
 */
export function resolveImpersonationServiceOrganizationIds({
  selectedServiceOrganizationIds,
  brandIds,
  brandServiceOrganizationIds,
  search
}: {
  selectedServiceOrganizationIds: number[];
  brandIds: number[];
  brandServiceOrganizationIds: number[] | undefined;
  search: string;
}): number[] | undefined {
  if (selectedServiceOrganizationIds.length > 0) {
    return selectedServiceOrganizationIds;
  }
  if (search.trim()) {
    return undefined;
  }
  if (brandIds.length === 0) {
    return undefined;
  }
  return brandServiceOrganizationIds;
}
